// @flow
import { compose } from 'recompose';
import { connect } from 'react-redux';

import WantedListsItem from './WantedListsItem';

export default compose(
  connect(
    state => ({}),
    dispatch => ({}),
  ),
)(WantedListsItem);
